export const rescaleImage = (input: {
  img: HTMLImageElement;
  width: number;
  height: number;
  imageNaturalDimensions: {
    width: number;
    height: number;
  };
}) => {
  const { width, height, imageNaturalDimensions } = input;

  const imgAspectRatio =
    imageNaturalDimensions.width / imageNaturalDimensions.height;
  const containerAspectRatio = width / height;

  let finalHeight = height;
  let finalWidth = width;

  if (imgAspectRatio > containerAspectRatio) {
    finalWidth = width;
    finalHeight = width / imgAspectRatio;
  } else {
    finalHeight = height;
    finalWidth = height * imgAspectRatio;
  }

  return {
    height: finalHeight,
    width: finalWidth,
  };
};
